export default __webpack_public_path__ + "static/media/8757088.318f3af7.jpg";